import { getFeatureConfig } from '@luna/feature-config';
import {
    isBrowserStackLocalEnvironment,
    isDevEnvironment,
    isLocalEnvironment,
} from '@shared/environment';

const HOSTED_REVERSE_PROXY_URL = 'https://rproxy.beeone.at';
const HOSTED_REVERSE_PROXY_URL_2 = 'https://dev-proxy-server.kek.g-labs.io/cors-proxy';

export function updateProxyUrlBasedOnEnvironment(url: string): string {
    const isAbsoluteUrl = /^(?:[a-z]+:)?\/\//i.test(url);
    const proxyUrl =
        getFeatureConfig((config) => config.reverseProxyVersion) === 'v2'
            ? HOSTED_REVERSE_PROXY_URL_2
            : HOSTED_REVERSE_PROXY_URL;

    const { hostname } = window.location;
    if (isBrowserStackLocalEnvironment(hostname)) {
        return [proxyUrl, url].join('/');
    }
    if (isLocalEnvironment() && isAbsoluteUrl) {
        return [proxyUrl, url].join('/');
    }
    if (isDevEnvironment(hostname) && isAbsoluteUrl) {
        return [proxyUrl, url].join('/');
    }

    return url;
}
